import { mvc } from "@clientio/rappid";

export class Renderer {
  static renderView(selector: string, view: mvc.View<undefined>): void {
    document.querySelector(selector)?.appendChild(view.el);
    view.render();
  }
}
